import styled from 'styled-components';
import Text from '@/styles/Themes/Text';
import { cssVars } from '@/styles/Themes/cssVars';
import Palette from '@/styles/Themes/Palette';

const Container = styled.div`
    position: relative;
    width: 100%;
    padding-top: 10px;

    #ab-tiny-widget {
        ${Text.Full.large.medium};
        color: ${cssVars.fg_gray2_gray3};
        margin: 0 !important;
        position: absolute;
        left: 0;
        background-color: ${cssVars.bg_white_blue};
    }

    #ab-tiny-widget span + a {
        color: ${Palette.green.normal};
    }
`;

const Placeholder = styled.button`
    ${Text.Full.large.medium};
    color: ${cssVars.fg_gray2_gray3};
    cursor: pointer;
    background: transparent;
    border: none;
    margin: 0;
    padding: 0;
`;

const Highlight = styled.span`
    color: ${Palette.green.normal};
`;

export const AnswerLink = () => {
    return (
        <Container>
            <Placeholder
                onClick={() => {
                    document?.querySelector?.('#answers')?.scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }}
                id="answer-link"
            >
                Have a product question? <Highlight>Ask us</Highlight>
            </Placeholder>
        </Container>
    );
};
